import React from "react"
import { StaticQuery, graphql } from "gatsby"
import Img from "gatsby-image"

const BannerBottom = () => (<StaticQuery
    query={graphql`
      query {
        bannerBottomOne: file(relativePath: { eq: "enduring-freedom.jpg" }) {
          childImageSharp {
            fluid(maxWidth: 1920, quality: 100) {
              ...GatsbyImageSharpFluid
            }
          }
        }
        bannerBottomTwo: file(relativePath: { eq: "for-the-crew.jpg" }) {
          childImageSharp {
            fluid(maxWidth: 1920, quality: 100) {
              ...GatsbyImageSharpFluid
            }
          }
        }
      }
    `}
    render={data =>
      <>
        <a href="https://www.youtube.com/watch?v=WLrYC_97Ch4" rel="noopener noreferrer" target="_blank">
          <Img fluid={data.bannerBottomOne.childImageSharp.fluid} />
        </a>
        <Img fluid={data.bannerBottomTwo.childImageSharp.fluid} />
      </>
    }
  />
)

export default BannerBottom;
